import React from "react"
import { useState, useEffect } from "react"
import "./PaymentOrder.scoped.scss"
import { apiClient, urlClientInfo } from "../../../../api"
import queryString from "query-string"
import { token } from "../../../../config"
import { useLocation, useHistory } from "react-router-dom"
import { PaymentMethodDisplay, TransectionErrorType } from "../../../../models/transection"
import moment from "moment"
import QRCode from "react-qr-code"
import ModalWarning from "../../../../components/Ants/Modal/ModalWarning"
import { Spin } from "antd"

const PaymentOrder = () => {
  const history = useHistory()
  const location = useLocation()
  const [timeLeft, setTimeLeft] = useState(0)
  const [clientInfo, setClientInfo] = useState({
    ipString: "",
    userAgent: "",
  })
  const [openModalError, setOpenModalError] = useState(false)
  const [statusMessage, setStatusMessage] = useState("")
  const [tempValue, setTempValue] = useState("")
  const [sourceType, setSourceType] = useState("")
  const [expireOrderDate, setExpireOrderDate] = useState("")
  const [packgageDetail, setPackgageDetail] = useState("")
  const [loading, setLoading] = useState(false)

  const startCountdown = (expireTime) => {
    if (expireTime) {
      const targetTime = new Date(expireTime).getTime()
      const now = new Date().getTime()
      const totalSeconds = Math.max(Math.floor((targetTime - now) / 1000), 0)

      setTimeLeft(totalSeconds) // ✅ initialize once
    }
  }


  const handleCheckPayment = async (client = clientInfo) => {
    setLoading(true)
    const { oid } = queryString.parse(location.search)
    let req = {
      orderId: oid,
      client,
    }

    await apiClient
      .post('api/ecom/validate-order', JSON.stringify(req), {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-type": "application/json; charset=UTF-8",
        },
      })
      .then((response) => {
        handleEventOrderStatus(response.data)
      })
      .catch((error) => {
        console.table(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleCheckStatus = (message, description = null, isred = false) => {
    setStatusMessage(message)
    setOpenModalError(true)
  }

  const handleEventOrderStatus = (response) => {
    switch (response.status) {
      case TransectionErrorType.ERROR:
        handleCheckStatus(response.message, response.description, true)
        // this.setState({
        //   redirectUrl: response.redirectTarget,
        //   showCreateOrderButton: true
        // })
        // this.setUrl(response.redirectTarget, 0)
        break
      case TransectionErrorType.CREATE_RECEIPT:
      case TransectionErrorType.ADD_CREDIT_LOG:
      case TransectionErrorType.INNTERNAL_ERROR:
      case TransectionErrorType.NOT_FOUND_ORDER:
      case TransectionErrorType.ERR_UPDATE_ACCPRICE:
        handleCheckStatus(response.message, response.description, true)
        break
      case TransectionErrorType.UPDATE_STATUS_ORDER_FAIL:
        handleCheckStatus(response.message, response.description)
        // this.setState({
        //   showRefreshButton: true
        // })
        break
      case TransectionErrorType.OMISE_CHARGE_NOT_SUCCESS:
        // handleCheckStatus(response.message, response.description)
        history.push(response.redirectTarget)
        // this.setState({
        //   redirectUrl: response.redirectTarget,
        //   showCreateOrderButton: true
        // })
        // this.setUrl(response.redirectTarget, 0)
        break
      case TransectionErrorType.ORDER_PENDING:
        setTempValue(response.tmpvalue)
        setSourceType(response.sourceType)
        setExpireOrderDate(response.order_expire_date)
        setPackgageDetail(response.packageDetail)
        startCountdown(response.order_expire_date)
        break
      case TransectionErrorType.ORDER_FAILED:
      case TransectionErrorType.ORDER_REVERSED:
      case TransectionErrorType.ORDER_EXPIRED:
        // handleCheckStatus(response.message, response.description)
        history.push(response.redirectTarget)
        break
      case TransectionErrorType.SUCCESS:
        handleCheckStatus(response.message, response.description)
        history.push(response.redirectTarget)
        break
      default:
        handleCheckStatus(response.message, response.description)
        break
    }
  }

  const getClientInfo = () => {
    urlClientInfo
      .get("", {
        headers: { "Content-type": "application/json; charset=UTF-8" },
      })
      .then((response) => {

        const info = {
          ipString: response.data.ipString,
          userAgent: response.data.userAgent,
        };
        setClientInfo(info);
        handleCheckPayment(info);
      })
      .catch((error) => {
        // this.setState({ clientInfo: "" })
      })
  }

  useEffect(() => {
    getClientInfo()
  }, [])

  useEffect(() => {
    if (timeLeft <= 0) return

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft])

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
  }

  const handleRedirect = () => {
    history.push("/PackageList")
  }

  return (
    <div className="payment-order">
      <Spin spinning={loading} >
        <div className="payment-order-container">
          <div className="header">
            <h1 className="title">Order</h1>
          </div>

          <div className="timer">
            <div className="timer-text-container">
              <p className="timer-text">Please pay within</p>
              <div className="source-type-container">
                {sourceType?.startsWith("Mobile") ? (
                  <img src={`/img/mobile-banking/${PaymentMethodDisplay[sourceType.toLowerCase()]?.path}.png`} alt="mobile-banking" style={{ width: "24px", height: "24px" }} />
                ) : (
                  <img src={`/img/payment-method/${PaymentMethodDisplay[sourceType.toLowerCase()]?.path}.png`} alt="payment" style={{ width: "24px", height: "24px" }} />
                )}
                <p className="source-type">{PaymentMethodDisplay[sourceType.toLowerCase()]?.name}</p>
              </div>
            </div>
            <div className="timer-display">
              <span className="countdown">{formatTime(timeLeft)}</span>
              <span className="date">{expireOrderDate ? moment(expireOrderDate).format("DD.MM.YYYY") : "-"}</span>
            </div>
          </div>

          <div className="payment-section">
            {/* <button className="paymentButton">
          <div className="paymentIcon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
              <path d="M7 15h.01M11 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
          <span className="paymentText">THAI QR PAYMENT</span>
        </button> */}

            <div className="qr-container">
              {sourceType !== PaymentMethodDisplay[sourceType.toLowerCase()]?.name ? (
              <QRCode value={tempValue} />
              ) : (
                <img src={tempValue} />
              )}
            </div>
          </div>

          <div className="details">
            <h3 className="details-title">Package Detail</h3>

            <div className="detail-row">
              <span className="detail-label">Plan</span>
              <span className="detail-value highlight">{packgageDetail.pkg_name}</span>
            </div>

            <div className="detail-row">
              <span className="detail-label">Price</span>
              <span className="detail-value">{packgageDetail?.pkg_price?.toLocaleString()} Baht</span>
            </div>

            <div className="detail-row">
              <span className="detail-label">Fee</span>
              <span className="detail-value">{packgageDetail?.pkg_with_fee?.toLocaleString()} Baht</span>
            </div>

            <div className="detail-row">
              <span className="detail-label">Discount</span>
              <span className="detail-value">{packgageDetail?.pkg_discount?.toLocaleString()} Baht</span>
            </div>

            {packgageDetail?.pkg_with_vat > 0 && (
              <div className="detail-row">
                <span className="detail-label">VAT 7%</span>
                <span className="detail-value">{packgageDetail?.pkg_with_vat?.toLocaleString()} Baht</span>
              </div>
            )}

            <div className="detail-row">
              <span className="detail-label bold">NET AMOUNT</span>
              <span className="detail-value total">{packgageDetail?.pkg_total?.toLocaleString()} Baht</span>
            </div>
          </div>
        </div>
      </Spin>

      <ModalWarning
        loading={loading}
        warningModalVisible={openModalError}
        warningModal={handleRedirect}
        successModal={() => setOpenModalError(false)}
        modalcountDown={() => setOpenModalError(false)}
        message={statusMessage}
        messageSuccess={""}
      />
    </div>
  )
}

export default PaymentOrder
